"use strict";

module.exports = {
  AS_src: 125,
  AS_dst: 125,
  IP_src: 75,
  IP_dst: 75,
  Port_src: 50,
  Port_dst: 50,
  src_route_length: 50,
  dst_route_length: 50,
  i_src_connect_type_name: 50,
  i_src_network_bndry_name: 50,
  i_dst_connect_type_name: 50,
  i_dst_network_bndry_name: 50,
  Proto: 75,
  TOS: 50,
  inet_family: 50,
  sampledpktsize: 50,
  sampledpktsize_100: 75,
  sample_rate: 75,
  kflow_dns_query_type: 75,
  kflow_dns_ret_code: 50,
  kflow_dns_response: 125,
  kflow_http_status: 50,
  kflow_http_ua: 125,
  ktappprotocol__event_syslog__INT64_00: 75,
  ktappprotocol__event_syslog__INT06: 50,
  ktappprotocol__event_syslog__STR05: 200
};